import {
  CButton,
  CCardHeader,
  CCol,
  CForm,
  CInput,
  CInvalidFeedback,
  CLabel,
  CRow,
  CSelect,
  CSpinner,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { apiCall, apiCallSPGet } from "src/_apiConfig/apiCall";
import Auth from "src/auth";

// import usersData from "../users/UsersData";
const EditUser = () => {
  const { authenticated } = Auth();
  const history = useHistory();
  let { id } = useParams();
  // eslint-disable-next-line no-unused-vars
  const [usersData, setuserData] = useState();
  const [loading, setloading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [userid, setUserId] = useState(id);
  const [emailId, setEmailId] = useState();
  const [mobile, setMobile] = useState();
  const [username, setUserName] = useState();
  const [houseNo, setHouseNo] = useState();
  const [streetName, setStreetName] = useState();
  const [area, setArea] = useState();
  const [city, setCity] = useState();
  const [disctrict, setDistrict] = useState();
  const [state, setState] = useState();
  const [pincode, setPincode] = useState();
  const [contact1, setContact1] = useState();
  const [contact2, setContact2] = useState();
  const [contact3, setContact3] = useState();
  const [contact4, setContact4] = useState();
  const [comtact5, setContact5] = useState();
  const [fax, setFax] = useState();
  const [alternateEmail, setAlternateEmail] = useState();
  const [roleId, setRoleId] = useState(1);
  const [subRoleId, setSubRoleId] = useState();
  const [circleId, setCircleId] = useState();
  const [districtId, setDistrictId] = useState();
  const [items, setItems] = useState([]);
  const [itemsCricle, setitemsCricle] = useState([]);
  const [isViewOnly, setIsViewOnly] = useState(false);

  const [roleMasterId, setRoleMasterId] = useState(0);
  const [itemsRoleRight, setitemsRoleRight] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  //const [errors, setErrors] = useState([]);

  useEffect(() => {
    getUserList();
    getDistrictList(true);
    getCircleListDrop(true);
    getRoleMasterList(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);
  const getUserList = async () => {
    setloading(true);
    //
    const header = new Headers();
    const response = await apiCall(
      `User/GetById?id=${userid}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response.json();

    if (response.status === 200) {
      setEmailId(jsonobj.emailId);
      setMobile(jsonobj.mobile);
      setUserName(jsonobj.username);
      setHouseNo(jsonobj.houseNo);
      setStreetName(jsonobj.streetName);
      setArea(jsonobj.area);
      setCity(jsonobj.city);
      setDistrict(jsonobj.disctrict);
      setState(jsonobj.state);
      setPincode(jsonobj.pincode);
      setContact1(jsonobj.contact1);
      setContact2(jsonobj.contact2);
      setContact3(jsonobj.contact3);
      setContact4(jsonobj.contact4);
      setContact5(jsonobj.comtact5);
      setFax(jsonobj.fax);
      setAlternateEmail(jsonobj.alternateEmail);
      setRoleId(jsonobj.roleId ? jsonobj.roleId : roleId);
      setSubRoleId(jsonobj.subRoleId ? jsonobj.subRoleId : subRoleId);
      setCircleId(jsonobj.circle_id);
      setDistrictId(jsonobj.district_id);
      setIsViewOnly(!!jsonobj.isViewOnly);
      setRoleMasterId(
        jsonobj.roleMasterId ? jsonobj.roleMasterId : roleMasterId
      );

      // setEmailId(jsonobj[0].emailId);
      // setMobile(jsonobj[0].mobile);
      // setUserName(jsonobj[0].username);
      // setHouseNo(jsonobj[0].houseNo);
      // setStreetName(jsonobj[0].streetName);
      // setArea(jsonobj[0].area);
      // setCity(jsonobj[0].city);
      // setDistrict(jsonobj[0].disctrict);
      // setState(jsonobj[0].state);
      // setPincode(jsonobj[0].pincode);
      // setContact1(jsonobj[0].comtact1);
      // setContact2(jsonobj[0].comtact2);
      // setContact3(jsonobj[0].comtact3);
      // setContact4(jsonobj[0].comtact4);
      // setContact5(jsonobj[0].comtact5);
      // setFax(jsonobj[0].fax);
      // setAlternateEmail(jsonobj[0].alternateEmail);
      // setRoleId(jsonobj[0].roleId ? jsonobj[0].roleId : roleId);
      // setSubRoleId(jsonobj[0].subRoleId ? jsonobj[0].subRoleId : subRoleId);
      // setCircleId(jsonobj[0].user_Circles);
      // setDistrictId(jsonobj[0].user_Districts);
    }
    setloading(false);
  };
  const getDistrictList = async () => {
    setloading(true);
    const header = new Headers();
    const distResponse = await apiCall(`District_Master`, "GET", header, null);
    const distJsonobj = await distResponse.json();
    if (distResponse.status === 200) {
      setItems(distJsonobj);
    }
    setloading(false);
  };
  const getCircleListDrop = async () => {
    setloading(true);
    const header = new Headers();
    const distResponse = await apiCall(`Circle_Master`, "GET", header, null);
    const distJsonobj = await distResponse.json();
    if (distResponse.status === 200) {
      setitemsCricle(distJsonobj);
    }
    setloading(false);
  };
  const getRoleMasterList = async () => {
    if (authenticated) {
      setloading(true);

      await apiCallSPGet(`RoleMaster/ActiveList`)
        .then((res) => {
          if (res.success) {
            setitemsRoleRight(res.data);
          }
          setloading(false);
        })
        .finally();
    }
  };

  const putUserData = async (e) => {
    e.preventDefault();
    setloading(true);
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      // Collect error messages
      const errorList = [];
      Array.from(form.elements).forEach((element) => {
        if (element.validity.valid === false) {
          console.log("eee:", element);
          errorList.push(`${element.name}: ${element.validationMessage}`);
        }
      });
      console.log("errorList : ", errorList);
      //setErrors(errorList);
      setSubmitted(true);
      setloading(false);
    } else {
      const header = new Headers();
      header.append("Content-Type", "application/json");
      const data = JSON.stringify({
        userid: userid,
        emailId: emailId,
        mobile: mobile,
        username: username,
        houseNo: houseNo,
        streetName: streetName,
        area: area,
        city: city,
        disctrict: disctrict,
        state: state,
        pincode: pincode,
        contact1: contact1,
        contact2: contact2,
        contact3: contact3,
        contact4: contact4,
        comtact5: comtact5,
        fax: fax,
        alternateEmail: alternateEmail,
        roleId: Number(roleId),
        subRoleId: Number(subRoleId),
        circleId: Number(circleId),
        districtId: Number(districtId),
        roleMasterId: Number(roleMasterId),
        isViewOnly: !!isViewOnly,
      });

      const response = await apiCall(`User/update`, "PUT", header, data);
      // ;$filter=contains(${order},%27asa%27)%20

      const jsonobj = await response.json();

      if (response.status === 200 && jsonobj === -2) {
        alert("user already exists with same email address");

        setloading(false);
        return;
      }
      // if (response.status === 200 && jsonobj === -3) {
      //   alert("user already exists with same mobile");

      //   setloading(false);
      //   return;
      // } else
      if (response.status === 200 && jsonobj !== -1 && jsonobj !== -2) {
        setloading(false);
        setuserData(jsonobj);
        history.push(
          authenticated.role === "CGMF" ? "/master/userlist" : "/userlist"
        );
      }
      setValidated(true);
    }
  };
  let cfoDrop = (
    <CCol xl={4} md={6} sm={12} className={"mb-2"}>
      <CLabel> Circle *:</CLabel>
      <CSelect
        required
        name={"Circle"}
        value={circleId === null ? " " : circleId}
        aria-label="Default select example"
        onChange={(e) => setCircleId(e.target.value)}
        invalid={
          (parseInt(circleId) === 0 || circleId === "") &&
          parseInt(subRoleId) === 2
            ? true
            : false
        }
        id="validationCustom19"
      >
        <option value="">Select Circle</option>
        {itemsCricle.map((item, key) => (
          <option key={key} value={item.circleId}>
            {item.name}
          </option>
        ))}
      </CSelect>
      <CInvalidFeedback className="validationCustom19">
        Please Select Circle
      </CInvalidFeedback>
    </CCol>
  );

  let dfoDrop = (
    <CCol xl={4} md={6} sm={12} className={"mb-2"}>
      <CLabel>District Union * : </CLabel>
      <CSelect
        required
        name={"District Union"}
        value={districtId === null ? " " : districtId}
        aria-label="Default select example"
        onChange={(e) => {
          setDistrictId(e.target.value);
        }}
        invalid={
          (parseInt(districtId) === 0 || districtId === "") &&
          parseInt(subRoleId) === 3
            ? true
            : false
        }
        id="validationCustom20"
      >
        <option value="">Select District Union</option>
        {items.map((item, key) => (
          <option key={key} value={item.districtId}>
            {item.name}
          </option>
        ))}
      </CSelect>
      <CInvalidFeedback className="validationCustom20">
        Please Select District
      </CInvalidFeedback>
    </CCol>
  );
  let cgmfDrop = (
    <CCol xl={4} md={6} sm={12} className={"mb-2"}>
      <CLabel>Role Right *: </CLabel>
      <CSelect
        required
        value={roleMasterId === null ? "" : roleMasterId}
        aria-label="Default select example"
        onChange={(e) => {
          setRoleMasterId(e.target.value);
        }}
        //invalid={Number(roleMasterId) === 0 ? true : false}
        invalid={submitted && Number(roleMasterId) === 0}
        id="validationCustom21RoleRight"
      >
        <option value="">Select Role Right </option>
        {itemsRoleRight.map((item, key) => (
          <option key={key} value={item.roleMasterId}>
            {item.roleName}
          </option>
        ))}
      </CSelect>
      <CInvalidFeedback className="validationCustom21">
        Please Select Role Right
      </CInvalidFeedback>
    </CCol>
  );

  const getDropComponent = (subRoleId) => {
    switch (parseInt(subRoleId)) {
      case 1:
        return cgmfDrop;
      case 2:
        return cfoDrop;
      case 3:
        return dfoDrop;
      default:
        return "";
    }
  };
  // const validateEmail = (email) => {
  //   console.log("validateEmail : " + email);
  //   // Simple regex for basic email validation
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  //   if (email !== undefined) {
  //     if (email.length > 0 && !emailRegex.test(email)) {
  //       return true; //"Invalid email address format";
  //     } else if (email.length > 0 && emailRegex.test(email)) {
  //       return false; //"Invalid email address format";
  //     }
  //   }
  //   return false;
  // };
  const validateEmail = (email) => {
    //console.log("validateEmail : " + email);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (email !== undefined && email !== null && email.length > 0) {
      return !emailRegex.test(email); // Return true if email is invalid
    }
    return false; // Return false if email is valid or empty
  };
  const [validated, setValidated] = useState(false);
  return (
    <>
      <CCardHeader className="mb-3">
        <CRow xl={12} className="pt-3 ">
          <CCol xl={10}>
            <h3>Edit User </h3>
          </CCol>
        </CRow>
      </CCardHeader>
      <CForm
        onSubmit={putUserData}
        noValidate
        validated={validated}
        className="was-validation"
      >
        {/* {errors.length > 0 && (
          <div className="alert alert-danger">
            <ul>
              {errors.map((error, index) => (
                <li key={index}>{error}</li>
              ))}
            </ul>
          </div>
        )} */}
        <CRow className="mb-3 ml-1 mr-1">
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Email Id *: </CLabel>
            <CInput
              type="email"
              name="emailId"
              value={emailId === null ? " " : emailId}
              onChange={(e) => setEmailId(e.target.value)}
              //required
              //invalid={emailId === "" ? true : false}
              disabled
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Mobile Number *: </CLabel>
            <CInput
              type="number"
              value={mobile === null ? " " : mobile}
              onChange={(e) => setMobile(e.target.value)}
              required
              invalid={mobile === "" ? true : false}
              id="validationCustom183MobileNumber"
            />
            <CInvalidFeedback className="validationCustom183">
              Please enter Mobile Number
            </CInvalidFeedback>
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> User Name *: </CLabel>
            <CInput
              type="text"
              value={username === null ? " " : username}
              onChange={(e) => setUserName(e.target.value)}
              required
              invalid={username === "" ? true : false}
              //invalid={submitted && validateEmail}
              id="validationCustom182UserName"
            />
            <CInvalidFeedback className="validationCustom182">
              Please enter User Name
            </CInvalidFeedback>
          </CCol>
          {/* </CRow> */}

          {/* <CRow className="mb-3 ml-5">
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> First Name : </CLabel>
            <CInput type="text" />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Middle Name : </CLabel>
            <CInput type="text"/>
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Last Name : </CLabel>
            <CInput type="text"/>
          </CCol>
        </CRow>
   */}
          {/* <CRow className="mb-3 ml-5"> */}
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> House Number. : </CLabel>
            <CInput
              type="text"
              value={houseNo === null ? " " : houseNo}
              onChange={(e) => setHouseNo(e.target.value)}
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Street Name : </CLabel>
            <CInput
              type="text"
              value={streetName === null ? " " : streetName}
              onChange={(e) => setStreetName(e.target.value)}
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Area : </CLabel>
            <CInput
              type="text"
              value={area === null ? " " : area}
              onChange={(e) => setArea(e.target.value)}
            />
          </CCol>
          {/* </CRow>

      <CRow className="mb-3 ml-5"> */}
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> City : </CLabel>
            <CInput
              type="text"
              value={city === null ? " " : city}
              onChange={(e) => setCity(e.target.value)}
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Disctrict : </CLabel>
            <CInput
              type="text"
              value={disctrict === null ? " " : disctrict}
              onChange={(e) => setDistrict(e.target.value)}
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> State : </CLabel>
            <CInput
              type="text"
              value={state === null ? " " : state}
              onChange={(e) => setState(e.target.value)}
            />
          </CCol>
          {/* </CRow>

      <CRow className="mb-3 ml-5"> */}
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Pincode : </CLabel>
            <CInput
              type="text"
              value={pincode === null ? " " : pincode}
              onChange={(e) => setPincode(e.target.value)}
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Contact 1 : </CLabel>
            <CInput
              type="text"
              value={contact1 === null ? " " : contact1}
              onChange={(e) => setContact1(e.target.value)}
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Contact 2 : </CLabel>
            <CInput
              type="text"
              value={contact2 === null ? " " : contact2}
              onChange={(e) => setContact2(e.target.value)}
            />
          </CCol>
          {/* </CRow>

      <CRow className="mb-3 ml-5"> */}
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Contact 3 : </CLabel>
            <CInput
              type="text"
              value={contact3 === null ? " " : contact3}
              onChange={(e) => setContact3(e.target.value)}
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Contact 4 : </CLabel>
            <CInput
              type="text"
              value={contact4 === null ? " " : contact4}
              onChange={(e) => setContact4(e.target.value)}
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Contact 5 : </CLabel>
            <CInput
              type="text"
              value={comtact5 === null ? " " : comtact5}
              onChange={(e) => setContact5(e.target.value)}
            />
          </CCol>
          {/* </CRow>

      <CRow className="mb-3 ml-5"> */}
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Fax : </CLabel>
            <CInput
              type="text"
              value={fax === null ? " " : fax}
              onChange={(e) => setFax(e.target.value)}
            />
          </CCol>
          <CCol xl={4} md={6} sm={12} className={"mb-2"}>
            <CLabel> Alternate Email Address :</CLabel>
            <CInput
              type="email"
              name="alternateEmail"
              value={alternateEmail === null ? " " : alternateEmail}
              onChange={(e) => setAlternateEmail(e.target.value)}
              invalid={validateEmail(alternateEmail)}
              id="validationCustom181alternateEmail"
            />
            <CInvalidFeedback className="validationCustom181">
              Please enter valid email address format
            </CInvalidFeedback>
          </CCol>
          {roleId === 1 && (
            <CCol xl={4} md={6} sm={12} className={"mb-2"}>
              <CLabel> Role *: </CLabel>
              <CSelect
                required
                value={subRoleId === null ? "" : subRoleId}
                aria-label="Default select example"
                onChange={(e) => {
                  setSubRoleId(e.target.value);
                }}
                invalid={submitted && Number(subRoleId) === 0}
                id="validationCustom18SubRole"
              >
                <option value="">Select Role</option>
                {/* <option value="">
                {subRoleId === 1
                  ? "CGMF"
                  : subRoleId === 2
                  ? "CFO"
                  : subRoleId === 3
                  ? "DFO"
                  : "Role is not selected"}
              </option> */}
                <option value={1}>CGMF</option>
                <option value={2}>CCF</option>
                <option value={3}>DFO</option>
              </CSelect>
              <CInvalidFeedback className="validationCustom18">
                Please enter Role
              </CInvalidFeedback>
            </CCol>
          )}
          {/* </CRow> */}

          {/* <CRow className="mb-3 ml-5"> */}
          {roleId === 1 && getDropComponent(subRoleId)}
          {/* </CRow>
      <CRow className="mb-3 ml-5" hidden={roleId === 1 ? false : true}> */}
          {roleId === 1 && (
            <CCol xl={4} md={6} sm={12} className={"mb-2"}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                IsViewOnly:
              </CLabel>
              <input
                style={{
                  margin: 10,
                }}
                id="chkIsViewOnly"
                placeholder=""
                type="checkbox"
                checked={isViewOnly ? true : false}
                onClick={() => {
                  setIsViewOnly(!isViewOnly);
                }}
              />
            </CCol>
          )}
        </CRow>

        <CRow className="mb-3 ml-2">
          <CCol>
            {loading ? (
              <CSpinner className="spinner-grow" color="success" />
            ) : (
              <div>
                <CButton type="submit" color="success">
                  Update
                </CButton>

                <CButton
                  color="danger"
                  className="ml-2"
                  to={
                    authenticated.role === "CGMF"
                      ? "/master/userlist"
                      : "/userlist"
                  }
                >
                  Cancel
                </CButton>
              </div>
            )}
          </CCol>
        </CRow>
      </CForm>
    </>
  );
};
export default EditUser;
